import shopifyGenericDefaults from '../shopify-generic/config.js';

function InitFunc() {
  shopifyGenericDefaults.InitFunc?.();

  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm_manufacturers')) {
    const unwantedPageWrappers = [['.grid .grid__item.grid__item--page', 'text-link-animated']];

    unwantedPageWrappers.forEach(([elemSelector, className]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(className);
    });
  }
}

export default {
  ...shopifyGenericDefaults,
  InitFunc,
  includes: ['shopify-generic'],
};
